document.addEventListener('DOMContentLoaded', function () {

  function getItemLabel(index, totalItems) {
    if (totalItems === 1) return 'Color';
    return 'Item ' + (index + 1);
  }
function updateSummary(bundle) {
  const existing = bundle.querySelector('.qb-summary');
  if (existing) existing.remove();
}
  function buildSwatches(selectorItem, totalItems) {
    if (selectorItem.querySelector('.qb-swatch-group')) return;
    const select = selectorItem.querySelector('.quantity-break__variant-select');
    if (!select) return;
    const options = Array.from(select.options).map(function(o) { return o.value; });
    const index = parseInt(selectorItem.dataset.selectIndex) || 0;
    const numSpan = selectorItem.querySelector('.quantity-break__selector-item__number');
    if (numSpan) numSpan.textContent = getItemLabel(index, totalItems);
    const group = document.createElement('div');
    group.className = 'qb-swatch-group';
    const swatchContainer = document.createElement('div');
    swatchContainer.className = 'qb-swatches';
    const label = document.createElement('span');
    label.className = 'qb-swatch-label';
    label.textContent = select.value;
    options.forEach(function(color) {
      const swatch = document.createElement('div');
      swatch.className = 'qb-swatch' + (color === select.value ? ' is-selected' : '');
      swatch.dataset.color = color;
      swatch.title = color;
      swatch.addEventListener('click', function () {
        select.value = color;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        swatchContainer.querySelectorAll('.qb-swatch').forEach(function(s) {
          s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');
        label.textContent = color;
        const bundle = selectorItem.closest('.quantity-break');
        if (bundle) updateSummary(bundle);
      });
      swatchContainer.appendChild(swatch);
    });
    group.appendChild(swatchContainer);
    group.appendChild(label);
    selectorItem.appendChild(group);
  }

  function initBundles() {
    const bundles = document.querySelectorAll('.quantity-break');
    bundles.forEach(function(bundle) {
      const items = bundle.querySelectorAll('.quantity-break__selector-item');
      items.forEach(function(item) { buildSwatches(item, items.length); });
      updateSummary(bundle);
    });
  }

  initBundles();
});